/** Better Auth can reject a request before Google is contacted. */
export function getSocialSignInError(error: {
  code?: string;
  status?: number;
  message?: string;
}): string {
  if (error.status === 429 || error.message?.includes("429")) {
    return "Too many tries. Take a breath and try again in a minute.";
  }
  if (
    error.code === "INVALID_CALLBACK_URL" ||
    error.code === "INVALID_REDIRECT_URL" ||
    error.code === "INVALID_ERROR_CALLBACK_URL" ||
    error.code === "INVALID_NEW_USER_CALLBACK_URL"
  ) {
    return "The return link was rejected. Open sign-in from the app and try again.";
  }
  return "We couldn't start Google sign-in. Try again.";
}
